import React from "react";
import { Form, Input, InputNumber } from 'antd';
import { PASSWORD_VALIDATION_CHECK } from "../../utils/constants";

const InputFormField = ({ name, label, privacyMode = false, number = false, validation = true }) => {
  // base rules (always required)
  const rules = [
    {
      required: true,
      message: `You need to select a ${name} from the list`,
    },
  ];

  // add extra validation rules depending on field name
  if (name === "email") {
    rules.push({
      type: "email",
      message: "Please enter a valid email address",
    });
  }

  if (name === "password") {
    rules.push({
      pattern: PASSWORD_VALIDATION_CHECK,
      message:
        "Password must contain at least 8 characters, one uppercase letter and one number",
    });
  }

  return (
    <Form.Item name={name} label={label} rules={validation ? rules : []}>
      {privacyMode ? <Input.Password /> : number ? <InputNumber style={{width: "100%"}}/>  : <Input />}
    </Form.Item>
  );
};

  export default InputFormField;